import React, { useEffect, useRef } from 'react';
import './AscendingLines.css';

const AscendingLines = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let animationFrameId;
    let lines = [];

    class Line {
      constructor() {
        this.reset();
        // Start from random y position initially
        this.y = canvas.height * Math.random();
      }

      reset() {
        this.x = Math.random() * canvas.width;
        this.y = canvas.height + Math.random() * 50;
        this.length = Math.random() * 50 + 20;
        this.speed = Math.random() * 1 + 0.5;
        this.width = Math.random() * 2 + 0.5;
        this.opacity = Math.random() * 0.5 + 0.1;
        // Add slight horizontal movement
        this.dx = (Math.random() - 0.5) * 0.2;
      }

      draw() {
        const gradient = ctx.createLinearGradient(
          this.x, this.y, 
          this.x, this.y - this.length
        );
        gradient.addColorStop(0, `rgba(37, 3, 255, ${this.opacity})`);
        gradient.addColorStop(1, 'rgba(37, 3, 255, 0)');

        ctx.beginPath();
        ctx.strokeStyle = gradient;
        ctx.lineWidth = this.width;
        ctx.moveTo(this.x, this.y);
        ctx.lineTo(this.x, this.y - this.length);
        ctx.stroke();
      }

      update() {
        this.y -= this.speed;
        this.x += this.dx;

        // Reset when line moves off screen
        if (this.y < -this.length) {
          this.reset();
        }
        // Wrap around horizontally
        if (this.x < 0) this.x = canvas.width;
        if (this.x > canvas.width) this.x = 0;
      }
    }

    const init = () => {
      lines = [];
      // Create more lines for a denser effect
      const numberOfLines = Math.floor(canvas.width / 10);
      for (let i = 0; i < numberOfLines; i++) {
        lines.push(new Line());
      }
    };

    const animate = () => {
      // Clear the canvas with full transparency
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      lines.forEach(line => {
        line.update();
        line.draw();
      });

      animationFrameId = requestAnimationFrame(animate);
    };

    const handleResize = () => {
      canvas.width = window.innerWidth;
      canvas.height = 400;
      init();
    };

    window.addEventListener('resize', handleResize);
    handleResize();
    animate();

    return () => {
      window.removeEventListener('resize', handleResize);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  return <canvas ref={canvasRef} className="ascending-lines" />;
};

export default AscendingLines; 